<div class="oase-fragebogenstatus">
	<mat-card appearance="outlined">
		<mat-card-title >
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>

		<div class="logpFilter" [style.display]="onDesktop()">
			<mat-form-field>
				<input matInput [matDatepicker]="vonpicker" [(ngModel)]="statusVon" (dateInput)="reloadWithData()"
				(click)="vonpicker.open()">
				<mat-label>Von</mat-label>
				<mat-datepicker-toggle matSuffix [for]="vonpicker"></mat-datepicker-toggle>
				<button matSuffix mat-icon-button class="suche" (click)="statusVon=null;reloadWithData()"
						matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"><mat-icon>close</mat-icon></button>
				<mat-datepicker #vonpicker></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<input matInput [matDatepicker]="bispicker" [(ngModel)]="statusBis" (dateInput)="reloadWithData()"
					   (click)="bispicker.open()">
				<mat-label>Bis</mat-label>
				<mat-datepicker-toggle matSuffix [for]="bispicker"></mat-datepicker-toggle>
				<button matSuffix mat-icon-button class="suche" (click)="statusBis=null;reloadWithData()"
						matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"><mat-icon>close</mat-icon></button>
				<mat-datepicker #bispicker></mat-datepicker>
			</mat-form-field>
			<mat-form-field>
				<mat-select [(ngModel)]="aktuelleTyp" (ngModelChange)="reloadWithData()" name="typ">
					<mat-option *ngFor="let typ of typen" [value]="typ">{{ typ }}</mat-option>
				</mat-select>
				<mat-label>{{ OBJ_LNG_NAME+'.typ' | translate:locale.language }}</mat-label>
			</mat-form-field>
			<mat-form-field>
				<mat-select [(ngModel)]="aktuelleStatus" (ngModelChange)="reloadWithData()" name="status">
					<mat-option *ngFor="let status of statusse" [value]="status">{{ status }}</mat-option>
				</mat-select>
				<mat-label>{{ OBJ_LNG_NAME+'.status' | translate:locale.language }}</mat-label>
			</mat-form-field>
			<mat-form-field>
				<mat-select [(ngModel)]="aktuelleFragebogenname" (ngModelChange)="reloadWithData()" name="fragebogenName">
					<mat-option *ngFor="let fragebogenname of fragebogennamen" [value]="fragebogenname">{{ fragebogenname }}</mat-option>
				</mat-select>
				<mat-label>{{ OBJ_LNG_NAME+'.fragebogenName' | translate:locale.language }}</mat-label>
			</mat-form-field>
			<button mat-raised-button (click)="export();">{{ OBJ_LNG_NAME+'.export' | translate:locale.language }}</button>
		</div>

		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort [style.display]="onDesktop()">

					<ng-container matColumnDef="lieferantNummer">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.lieferantNummer' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.lieferantNummer }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="lieferantName">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">{{ OBJ_LNG_NAME+'.lieferantName' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="15" *matCellDef="let row">

							{{ row.lieferantName }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="fragebogenName">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="26">{{ OBJ_LNG_NAME+'.fragebogenName' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="26" *matCellDef="let row">

							{{ row.fragebogenName }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ablaufdatum">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.ablaufdatumFormat }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="typ">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.typ' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.typ }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="status">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.status' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

						<span *ngIf="row.status == 0" class="primary-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.nichtAbgeschlossen' | translate:locale.language }}</span>
						<span *ngIf="row.status == 1" class="warn-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.warten' | translate:locale.language }}</span>
						<span *ngIf="row.status == 2" class="green-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.abgeschlossen' | translate:locale.language }}</span>

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="letzteAenderung">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.letzteAenderung' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.letzteAenderungFormat }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="aktion">
						<mat-header-cell *matHeaderCellDef fxFlex="9">{{ OBJ_LNG_NAME+'.aktion' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="9" *matCellDef="let row">

						<button mat-raised-button *ngIf="row.status == 0 && (row.typNumber == 1 || row.typNumber == 3)
														&& row.vonPflichtBefreit != true"
						(click)="befreieVonPflicht(row)">{{ OBJ_LNG_NAME+'.befreien' | translate:locale.language }}</button>
						<button mat-raised-button *ngIf="row.status == 1" (click)="bestaetigeFragebogen(row)">{{ OBJ_LNG_NAME+'.bestaetigen' | translate:locale.language }}</button>
						<span *ngIf="row.status == 0 && row.vonPflichtBefreit == true" class="primary-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.befreit' | translate:locale.language }}</span>

						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>

				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">
		<mat-card appearance="outlined" *ngFor="let lieferantfragebogen of dataSource.content">
			<mat-card-title>
				{{ OBJ_LNG_NAME+'.lieferantNummer' | translate:locale.language }} : {{ lieferantfragebogen.lieferantNummer }}
			</mat-card-title>
			<mat-card-subtitle>
				{{ OBJ_LNG_NAME+'.lieferantName' | translate:locale.language }} : {{ lieferantfragebogen.lieferantName }}
			</mat-card-subtitle>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.fragebogenName' | translate:locale.language }} : {{ lieferantfragebogen.fragebogenName }}
			</mat-card-content>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }} : {{ lieferantfragebogen.ablaufdatumFormat }}
			</mat-card-content>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.status' | translate:locale.language }} :
					<span *ngIf="lieferantfragebogen.status == 0" class="primary-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.nichtAbgeschlossen' | translate:locale.language }}</span>
					<span *ngIf="lieferantfragebogen.status == 1" class="warn-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.warten' | translate:locale.language }}</span>
					<span *ngIf="lieferantfragebogen.status == 2" class="green-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.abgeschlossen' | translate:locale.language }}</span>
			</mat-card-content>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.letzteAenderung' | translate:locale.language }} : {{ lieferantfragebogen.letzteAenderungFormat }}
			</mat-card-content>
			<mat-card-actions align="end">
				<button mat-raised-button *ngIf="lieferantfragebogen.status == 0 && (lieferantfragebogen.typNumber == 1 || lieferantfragebogen.typNumber == 3)
															&& lieferantfragebogen.vonPflichtBefreit != true"
						(click)="befreieVonPflicht(lieferantfragebogen)">{{ OBJ_LNG_NAME+'.befreien' | translate:locale.language }}</button>
				<button mat-raised-button *ngIf="lieferantfragebogen.status == 1" (click)="bestaetigeFragebogen(lieferantfragebogen)">{{ OBJ_LNG_NAME+'.bestaetigen' | translate:locale.language }}</button>
				<span *ngIf="lieferantfragebogen.status == 0 && lieferantfragebogen.vonPflichtBefreit == true" class="primary-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.befreit' | translate:locale.language }}</span>
			</mat-card-actions>
		</mat-card>
	</div>
</div>
